module.exports = __webpack_public_path__ + "static/media/gryphon-nova-logo.1eb403f2.svg";